export const PERSONA_TOOLTIP_MAP: Record<string, string> = {
    'Younger Building Families':
        'Focus on upward mobility, tax-advantaged growth, and “catch-up” opportunities for long-term security.',
    'Older Earned Families': 'Emphasize wealth protection, legacy planning, and advisor-style reassurance.',
    'Rising Families and Striving Families':
        'Keep it simple, stress affordability and protection first, and build trust with clear, jargon-free explanations.',
};
